module.exports = __webpack_public_path__ + "img/191.fd32fca6.jpg";